import { render, staticRenderFns } from "./TheNavigationLayout.vue?vue&type=template&id=22f47de0&scoped=true"
import script from "./TheNavigationLayout.vue?vue&type=script&lang=ts"
export * from "./TheNavigationLayout.vue?vue&type=script&lang=ts"
import style0 from "./TheNavigationLayout.vue?vue&type=style&index=0&id=22f47de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f47de0",
  null
  
)

export default component.exports